import * as yup from 'yup';
import { decimal, decimalPoints, englishTestScore, wholeNumber, } from './methods/number.methods';
import { validGradeCheck } from './methods/string.methods';
yup.addMethod(yup.string, "validGradeCheck", validGradeCheck);
yup.addMethod(yup.number, "decimal", decimal);
yup.addMethod(yup.number, "wholeNumber", wholeNumber);
yup.addMethod(yup.number, "englishTestScore", englishTestScore);
yup.addMethod(yup.number, "decimalPoints", decimalPoints);
yup.addMethod(yup.string, "decimalPoints", decimalPoints);
export default yup;
//# sourceMappingURL=yupInstance.js.map